import React from 'react'

const MovieContainer = () => {
  return (
    <div>MovieContainer</div>
  )
}

export default MovieContainer